import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=de53e1d4&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=de53e1d4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de53e1d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de53e1d4')) {
      api.createRecord('de53e1d4', component.options)
    } else {
      api.reload('de53e1d4', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=de53e1d4&scoped=true&", function () {
      api.rerender('de53e1d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fc7LMPXp1UAd/JS/comp/Paginate.vue"
export default component.exports